import { jsx as _jsx } from "react/jsx-runtime";
import PageLayout from '../../../layout/page-layout';
import { DiscussionDetail } from '../../_shared/discussions';
import { useAuth } from '../../../hooks/useAuth';
import { districtRoutes } from '../../../common/routes/district';
function DistrictDiscussionDetail(props) {
    const [auth] = useAuth();
    return (_jsx(PageLayout, { children: _jsx("div", { className: "bg-light-subtle py-5", children: _jsx(DiscussionDetail, { discussionId: props.id, baseUrl: districtRoutes.discussions.getURL(), readOnly: !auth.isAuthenticated }) }) }));
}
export default DistrictDiscussionDetail;
